import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  ProgramTypesGUID,
  EventsPaymentScheduleTab,
  ProgramTypes
} from '../../models/_enum-collections';
import { OsmosisService } from '../services/osmosis.service';
import { CommonSharedModule } from '../common/shared.module';
import { EventsPaymentScheduleMilestone1Component } from './events-payment-schedule-milestone1/events-payment-schedule-milestone1.component';
import { EventsPaymentScheduleMilestone2Component } from './events-payment-schedule-milestone2/events-payment-schedule-milestone2.component';
import { CsiPaymentScheduleMilestone1Component } from '../csi-payment-schedule/csi-payment-schedule-milestone1/csi-payment-schedule-milestone1.component';
import { CsiPaymentScheduleMilestone2Component } from '../csi-payment-schedule/csi-payment-schedule-milestone2/csi-payment-schedule-milestone2.component';

@Component({
  selector: 'app-events-payment-schedule',
  templateUrl: './events-payment-schedule.component.html',
  styleUrls: ['./events-payment-schedule.component.scss'],
  standalone: true,
  imports: [
    CommonSharedModule,
    EventsPaymentScheduleMilestone1Component,
    EventsPaymentScheduleMilestone2Component,
    CsiPaymentScheduleMilestone1Component,
    CsiPaymentScheduleMilestone2Component
  ]
})
export class EventsPaymentScheduleComponent implements OnInit {
  tabList!: PaymentScheduleTabDetailsModel[];
  isEventMilestone2PaymentsEnabled = false;
  selectedProgramOption!: string;
  programTypesGUID!: ProgramTypesGUID;
  selectedTab = 0;

  constructor(
    private osmService: OsmosisService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    if (history.state.selectedProgramOption) {
      this.selectedProgramOption = history.state.selectedProgramOption;
    } else if (history.state.programTypeGuid) {
      this.selectedProgramOption =
        this.getSelectedProgramOptionByProgramTypeGuid(
          history.state.programTypeGuid
        );
    } else {
      this.selectedProgramOption = 'Events';
    }

    this.tabList = [
      new PaymentScheduleTabDetailsModel(true, true),
      new PaymentScheduleTabDetailsModel()
    ];

    const tabName = this.route.snapshot.queryParamMap.get('tab');
    const tabSelected = tabName as EventsPaymentScheduleTab;
    if (tabSelected === EventsPaymentScheduleTab.Milestone2) {
      this.isEventMilestone2PaymentsEnabled = true;
      this.tabList[0].isTabSelected = false;
      this.tabList[0].hasTabLoaded = false;

      this.tabList[1].isTabSelected = true;
      this.tabList[1].hasTabLoaded = true;
      this.selectedTab = 1;
    } else {
      this.osmService
        .isFeatureEnabled('EventMilestone2Payments', ProgramTypes.Events)
        .subscribe(
          response => (this.isEventMilestone2PaymentsEnabled = response)
        );

      this.tabList[0].isTabSelected = true;
      this.tabList[0].hasTabLoaded = true;

      this.tabList[1].isTabSelected = false;
      this.tabList[1].hasTabLoaded = false;
      this.selectedTab = 0;
    }
  }

  get isMilestone2PaymentsEnabled(): boolean {
    return this.isEventMilestone2PaymentsEnabled;
  }

  get isMilestone1Selected(): boolean {
    return this.tabList[0].isTabSelected;
  }

  onTabChange(event) {
    this.tabList.forEach(tab => {
      tab.isTabSelected = false;
    });
    this.tabList[event].hasTabLoaded = true;
    this.tabList[event].isTabSelected = true;
  }

  onOptionSelect(event: any) {
    this.selectedProgramOption = event.target.value;
    switch (this.selectedProgramOption) {
      case 'Events':
        this.programTypesGUID = ProgramTypesGUID.Events;
        break;
      case 'MRPP':
        this.programTypesGUID = ProgramTypesGUID.MRPP;
        break;
      case 'CSI':
        this.programTypesGUID = ProgramTypesGUID.MSSP;
        break;
    }
  }

  getSelectedProgramOptionByProgramTypeGuid(
    ProgramType: ProgramTypesGUID
  ): string {
    this.programTypesGUID = ProgramType;
    let selectedProgramOption = 'Events';
    switch (ProgramType) {
      case ProgramTypesGUID.MRPP:
        selectedProgramOption = 'MRPP';
        break;
      case ProgramTypesGUID.Events:
        selectedProgramOption = 'Events';
        break;
      case ProgramTypesGUID.MSSP:
        selectedProgramOption = 'CSI';
        break;
    }
    return selectedProgramOption;
  }
}

export class PaymentScheduleTabDetailsModel {
  hasTabLoaded: boolean;
  isTabSelected: boolean;

  constructor(hasTabLoaded = false, isTabSelected = false) {
    this.hasTabLoaded = hasTabLoaded;
    this.isTabSelected = isTabSelected;
  }
}
